<template>
    <!-- <section class="section-hero  cto-founder courses-hero"> -->
    <section class="section-hero" style="padding-bottom: 0.5rem;">
      <div class="hero container">
        <div class="hero-content">
            <h1 class="heading-primary">{{$t('Financial Education Courses')}}</h1>
            
                
                <div class="section-header">
                    
                    <h2 class="heading-secondary">
                      {{$t('coursesHeader')}}
                
               
                    </h2>
                    <template v-if="i18nService.currentLocale == 'fr'">
                       <p class="signup-free value-description"><a style="cursor:pointer;" @click="goToSignup()">L'inscription est gratuite</a> (aucune carte de crédit requise). Une fois votre compte créé, vous pouvez consulter ou acheter n'importe lequel des cours listés ci-dessous.</p>
                    </template>
                      
                    <template v-else>
                    <p class="signup-free value-description">It's free to <a style="cursor:pointer;" @click="goToSignup()">signup for an account</a> (no credit card required).  Once you have an account you can then preview or register for any of the courses listed below.</p>
                     <p class="signup-free value-description">Remember, all current and future courses are free for <a href="/pricing">Premium Plus Subscribers</a>!</p>
                    </template>
                  </div>
               <div class="founder-avatar">
                    <img src="/assets/foundations-450x300.png"  style="width:45rem;border-radius:16px;"/>
                    
                </div>
            
            
            <div v-if="isQTradeOn()" class="hero-founder courses-header" style="margin-top: 1rem;">
                <section class="home-education">
                  <div class="container section-value-props section-education hidden">
                    <div class="section-header">
                      
                      <!-- <h2 class="heading-secondary">{{$t("Courses for every stage of your investing journey.")}}</h2> -->
                      <Card>
                         <template #header>
                          <img alt="user header" src="/assets/qtrade-logoon-white.jpeg" style="max-width:25rem;"/> 
                          </template>
                        <template #title>
                            {{$t('Special Offer!')}}
                        </template>
                        <template #content>
                          <p class="value-description">{{$t('All Qtrade customers will receive an additional discount off the listed course price.')}}</p>
                          <p class="value-description">{{$t("Don't have a Qtrade account yet?")}}  <a target="_" href="https://links.invrs.com/gadv/01/bkpQSlZrK1BMMmlpUHQveWlscEY0cDRtMTJONS9RU3kzNFZBUmpzTFZMK2hFMlU5V1ZzMktpMnV2Z1NlaFN0WW5MbjJvcFAvOGxJc3dsWTJrRUZQWFE9PQ">{{$t('Signup with Qtrade')}}</a> {{$t("and visit us from their partner education page to get your discount.")}}</p>
                        </template>
                       </Card>
                    </div>
                    
                    
                  </div>
                </section>
            </div>
        </div>
      </div>
    </section>
    <section>
        
        <div class="hero-content">    
            <div class=" hero-founder cto-founder" style="margin-left:auto;margin-right:auto;">
                <section class="home-education" > 
                  <div class="section-header">
                    
                  </div>
                  <div class="container section-value-props section-education">
                    <div >
                      
                      <!-- <h2 class="heading-course-cat">{{$t("Beginner Level Courses")}}</h2> -->
                      <h2 class="heading-course-cat">{{$t("Investing Courses")}}</h2>
                      <!-- <p class="signup-free value-description">It's free to signup for an account(no credit card required).  Once you have an account you can then preview or purchase any of the courses listed below.</p> -->
                    </div>

                    <DataView :value="investingCourses" :dataKey="'name'" :layout="'grid'" :lazy="false"> 
                    <template #grid="slotProps">
                      
                        
                            
                            <div class="a-row col-12 sm:col-6 md:col-6 xl:col-6" >
                              
                                
                                    <div class="relative mx-auto course-box" >
                                        <div class="course-div">
                                       <img :src="slotProps.data.iconUrl"  class="course-img" @click="openCourseInfo(slotProps.data)"/>
                                        </div>
                                        <div class="course-info">
                                            <div ><h3 class="heading-tertiary" @click="openCourseInfo(slotProps.data)">{{ $t(slotProps.data.name) }}</h3></div>
                                            <div class="course-desc-cont" @click="openCourseInfo(slotProps.data)"><p class="value-description" v-html="getShortDesc(slotProps.data)"></p>
                                            <div v-if="slotProps.data.note" class="course-desc-cont" >
                                              <p class="value-description" ><small><b>{{$t(slotProps.data.note)}}</b></small></p></div>
                                            <div class="more-info" @click="openCourseInfo(slotProps.data)" style="margin-bottom:1rem;">{{$t('More info...')}}</div>
                                           <template v-if="slotProps.data.langs.length == 1">
                                              <span style="font-size:1.2rem;">{{$t('Available Languages: English, French coming soon!')}}</span>
                                            </template>
                                            <template v-else>
                                              <span style="font-size:1.2rem;">{{$t('Available Languages: English and French')}} </span>
                                            </template>
                                            </div>
                                             
                                                    
                                            
                                            <div class="pricing-header" >
                                              <div class="course-pricing-cont">
                                                <span class="course-price-label" v-if="slotProps.data.cdnPrice || slotProps.data.usPrice">{{$t('Price')}}:</span>
                                                <div class="course-pricing">
                                                  <span class="course-price" v-if="slotProps.data.cdnPrice">{{slotProps.data.cdnPrice}} CAD</span>
                                                  <span class="course-price" v-if="slotProps.data.usPrice">{{slotProps.data.usPrice}} USD</span>
                                                 
                                                
                                                </div>
                                              </div>
                                              <template v-if="isQTradeOn() && slotProps.data.cdnDiscPrice">
                                                <div class="course-pricing-cont">
                                                  <span class="course-price-label">{{$t('Qtrade')}}:</span>
                                                  <div class="course-pricing">
                                                  
                                                    <span class="course-price" >{{slotProps.data.cdnDiscPrice}} CAD</span>
                                                  
                                                  </div>
                                                </div>
                                              </template> 
                                               <div v-if="slotProps.data.cdnPrice" class="course-pricing-cont">
                                                <span class="course-price-label"><a href="/pricing">Premium Plus</a>:</span>
                                                <div class="course-pricing">
                                                
                                                  <span class="course-price" >Free!</span>
                                                
                                                </div>
                                              </div>
                                              
                                            </div>
                                           
                                            <a class="cta btn"   @click="goToSignup(slotProps.data.signupCode)" >{{$t('Sign Up')}}</a>
                                            
                                        </div>
                                        
                                        
                                    </div>
                                    <hr class="course-line"/>
                                   
                                    
                                
                            </div>
                      
                    </template>
                    
                  
                </DataView>

                    
                    
                  </div>
                </section>
            </div>
            <div class=" hero-founder cto-founder">
                <section class="home-education">
                  <div class="container section-value-props section-education hidden">
                    <div >
                      
                      <!-- <h2 class="heading-course-cat">{{$t("Intermediate Level Courses")}}</h2> -->
                      <h2 class="heading-course-cat">{{$t("Financial Literacy Courses")}}</h2>
                      <!-- <p class="signup-free value-description">It's free to signup for an account(no credit card required).  Once you have an account you can then preview or purchase any of the courses listed below.</p> -->
                    </div>
                    <DataView :value="litCourses" :dataKey="'name'" :layout="'grid'" :lazy="false"> 
                      <template #grid="slotProps">
                        
                          
                              
                              <div class="a-row col-12 sm:col-6 md:col-6 xl:col-6" >
                                
                                  
                                      <div class="relative mx-auto course-box">
                                          <div>
                                          <img :src="slotProps.data.iconUrl"   class="course-img" @click="openCourseInfo(slotProps.data)"/>
                                          </div>
                                          <div class="course-info">
                                              <div ><h3 class="heading-tertiary" @click="openCourseInfo(slotProps.data)">{{ $t(slotProps.data.name) }}</h3></div>
                                              <div class="course-desc-cont" @click="openCourseInfo(slotProps.data)"><p class="value-description">{{ getShortDesc(slotProps.data)}}</p>
                                              <div class="more-info" @click="openCourseInfo(slotProps.data)" style="margin-bottom:1rem;">{{$t('More info...')}}</div>
                                              <template v-if="slotProps.data.langs.length == 1">
                                              <span style="font-size:1.2rem;">{{$t('Available Languages: English, French coming soon!')}}</span>
                                            </template>
                                            <template v-else>
                                              <span style="font-size:1.2rem;">{{$t('Available Languages: English and French')}} </span>
                                            </template>
                                              </div>
                                              
                                    
                                             <div class="pricing-header" >
                                              <div class="course-pricing-cont">
                                                <span class="course-price-label" v-if="slotProps.data.cdnPrice || slotProps.data.usPrice">{{$t('Price')}}:</span>
                                                <div class="course-pricing">
                                                <span class="course-price" v-if="slotProps.data.cdnPrice">{{slotProps.data.cdnPrice}} CAD</span>
                                                <span class="course-price" v-if="slotProps.data.usPrice">{{slotProps.data.usPrice}} USD</span>
                                                
                                                </div>
                                              </div>
                                              <template v-if="isQTradeOn() && slotProps.data.cdnDiscPrice">
                                                <div class="course-pricing-cont">
                                                  <span class="course-price-label">{{$t('Qtrade')}}:</span>
                                                  <div class="course-pricing">
                                                  
                                                    <span class="course-price" >{{slotProps.data.cdnDiscPrice}} CAD</span>
                                                  
                                                  </div>
                                                </div>
                                              </template> 
                                              <div v-if="slotProps.data.cdnPrice" class="course-pricing-cont">
                                                <span class="course-price-label"><a href="/pricing">Premium Plus</a>:</span>
                                                <div class="course-pricing">
                                                
                                                  <span class="course-price" >Free!</span>
                                                
                                                </div>
                                              </div>
                                               
                                            </div>
                                             <a class="cta btn"   v-if="slotProps.data.cdnPrice || slotProps.data.usPrice" @click="goToSignup(slotProps.data.signupCode)" >{{$t('Sign Up')}}</a>
                                          </div>
                                            
                                      </div>
                                      
                                      <hr class="course-line"/>
                                      
                                  
                              </div>
                        
                      </template>
                      
                    
                  </DataView>
                    
                    
                  </div>
                </section>
            </div>
            <div class=" hero-founder cto-founder">
                <section class="home-education">
                  <div class="container section-value-props section-education hidden">
                    <div >
                      
                      <h2 class="heading-course-cat">{{$t("Specialty Courses")}}</h2>
                      <!-- <p class="signup-free value-description">It's free to signup for an account(no credit card required).  Once you have an account you can then preview or purchase any of the courses listed below.</p> -->
                    </div>
                    <DataView :value="customCourses" :dataKey="'name'" :layout="'grid'" :lazy="false"> 
                      <template #grid="slotProps">
                        
                          
                              
                              <div class="a-row col-12 sm:col-6 md:col-6 xl:col-6" >
                                
                                  
                                      <div class="relative mx-auto course-box">
                                          <div>
                                          <img :src="slotProps.data.iconUrl"   class="course-img" @click="openCourseInfo(slotProps.data)"/>
                                          </div>
                                          <div class="course-info">
                                              <div ><h3 class="heading-tertiary" @click="openCourseInfo(slotProps.data)">{{ $t(slotProps.data.name) }}</h3></div>
                                              <div class="course-desc-cont" @click="openCourseInfo(slotProps.data)"><p class="value-description">{{ getShortDesc(slotProps.data) }}</p>
                                              <div class="more-info" @click="openCourseInfo(slotProps.data)" style="margin-bottom:1rem;">{{$t('More info...')}}</div>
                                              <template v-if="slotProps.data.langs.length == 1">
                                              <span style="font-size:1.2rem;">{{$t('Available Languages: English, French coming soon!')}}</span>
                                            </template>
                                            <template v-else>
                                              <span style="font-size:1.2rem;">{{$t('Available Languages: English and French')}} </span>
                                            </template>
                                              </div>
                                              
                                    
                                             <div class="pricing-header" >
                                              <div class="course-pricing-cont">
                                                <span class="course-price-label">{{$t('Price')}}:</span>
                                                <div class="course-pricing">
                                                  <span class="course-price" v-if="slotProps.data.cdnPrice">{{slotProps.data.cdnPrice}} CAD</span>
                                                <span class="course-price" v-if="slotProps.data.usPrice">{{slotProps.data.usPrice}} USD</span>
                                                
                                                <span class="course-price" v-if="!slotProps.data.cdnPrice && !slotProps.data.usPrice">contact info&commat;invrs.com</span>
                                                </div>
                                              </div>
                                              <template v-if="isQTradeOn() && slotProps.data.cdnDiscPrice">
                                                <div class="course-pricing-cont">
                                                  <span class="course-price-label">{{$t('Qtrade')}}:</span>
                                                  <div class="course-pricing">
                                                  
                                                    <span class="course-price" >{{slotProps.data.cdnDiscPrice}} CAD</span>
                                                  
                                                  </div>
                                                </div>
                                              </template> 
                                               <div v-if="slotProps.data.cdnPrice" class="course-pricing-cont">
                                                <span class="course-price-label"><a href="/pricing">Premium Plus</a>:</span>
                                                <div class="course-pricing">
                                                
                                                  <span class="course-price" >Free!</span>
                                                
                                                </div>
                                              </div>
                                            </div>
                                            <a class="cta btn"   v-if="slotProps.data.signupCode" @click="goToSignup(slotProps.data.signupCode)" >{{$t('Sign Up')}}</a>
                                             
                                          </div>
                                            
                                      </div>
                                      <hr class="course-line"/>
                                      
                                    
                                      
                                  
                              </div>
                        
                      </template>
                      
                    
                  </DataView>
                    
                  </div>
                </section>
            </div>
            
        </div>
    </section>
    <CourseInfoModal ref="courseInfoModal"/>
  </template>
  
  <script>
import { SIGNUP_URL, QTRADE_REF_ON } from "../config.js";
import DataView from "primevue/dataview";
import Card from "primevue/card";
//import Button from "primevue/button";


import CourseInfoModal from '../components/education/CourseInfoModal.vue';
import i18nService from '../i18n.js';

  export default {
    name: "CoursesPage",

    components: {
       // Avatar
       DataView,
       CourseInfoModal,
       Card,
      // Button,
    
    },
    head() {
      return {
        title: "INVRS - Courses",
        meta:[
          { 
            name: "description",
            content: 'We offer beginner courses like Financial Literacy and Investment Foundations, Intermediate courses like Build and Manage an Investment Portfolio, career courses like Recruitment Prep, and specialty courses like Game Plan: Financial Literacy for Elite Athletes.'
          },
          { 
            name: "twitter:title",
            content: 'INVRS - Courses.'
          },
          { 
            name: "twitter:description",
            content: 'We offer beginner courses like Financial Literacy and Investment Foundations, Intermediate courses like Build and Manage an Investment Portfolio, career courses like Recruitment Prep, and specialty courses like Game Plan: Financial Literacy for Elite Athletes.'
          },
          { 
            name: "og:title",
            content: 'INVRS - Courses.'
          },
          { 
            name: "og:description",
            content: 'We offer beginner courses like Financial Literacy and Investment Foundations, Intermediate courses like Build and Manage an Investment Portfolio, career courses like Recruitment Prep, and specialty courses like Game Plan: Financial Literacy for Elite Athletes.'
          },
        ]
      }
    },

    data() {
      return {
         i18nService,
        heroSection: "",
        heroContent: "",
        ceoFounder: "",
        ctoFounder: "",
        ceoFounderImagePath: "../../assets/ceo-founder.jpg",
        obsOptionsHero: {
          root: null,
          threshold: 0.1,
        },
        investingCourses:[
          { 
            name: this.$t("Foundation"), 
            shortDescription: {
              en: `Think you can learn everything you need to know about investing from social media and other "free" sources?  Discover just how much you don't know.  Build a rock solid foundation with this course written by a CFA. `,
              fr: `Vous pensez pouvoir apprendre tout ce qu'il faut savoir sur l'investissement grâce aux réseaux sociaux et à d'autres sources « gratuites » ?  Découvrez tout ce que vous ignorez.  Bâtissez des bases solides grâce à cette formation conçue par un CFA.`
            },
            description: {
              en: `Think you can learn everything you need to know about investing from social media, free internet sources, or AI?
Here's the problem with that approach: You Don't Know What You Don't Know!<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;With ad hoc education you have no way to tell if you have a complete understanding that is free from bias, misrepresentation or error. Those holes, or worse errors, in your understanding can cost you time and money.
Foundation was written by a CFA (Chartered Financial Analyst) so you can be sure it covers everything you need to know as a beginner or self-taught investor.<br>  
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The course covers what investing is and isn't, a bit of the history for context and how it all works in today's day and age.  We cover the different kinds of investible assets and explore where returns comes from.  You will learn investment concepts like risk, diversification, time value of money, present value, yield-to-maturity, and yield curves to name a few.
You'll learn about important market players like market makers and central banks.  You'll learn all the trading basics, and you'll get the opportunity to place various kinds of orders on our trading simulator.  We also weave in fraud awareness throughout the whole course.<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Finally, we help you decide whether being a do-it-yourself investor is for you or whether you are more suited to working with an advisor.
Like all of our courses, Foundation includes the newest investment thinking.  Even if you are an experienced investor, we guarantee you'll learn something new.`, 
              fr: `Vous pensez pouvoir apprendre tout ce qu'il faut savoir sur l'investissement grâce aux réseaux sociaux, aux ressources gratuites disponibles sur Internet ou à l'intelligence artificielle ?
Voici le problème avec cette approche : vous ne savez pas ce que vous ne savez pas !<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Avec une formation ponctuelle, vous n'avez aucun moyen de savoir si vous avez une compréhension complète, exempte de préjugés, d'inexactitudes ou d'erreurs. Ces lacunes, voire ces erreurs, dans votre compréhension peuvent vous coûter du temps et de l'argent.
Foundation a été rédigé par un CFA (Chartered Financial Analyst), vous pouvez donc être sûr qu'il couvre tout ce que vous devez savoir en tant que débutant ou investisseur autodidacte.<br>  
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Le cours couvre ce qu'est et ce que n'est pas l'investissement, un peu d'histoire pour replacer le contexte et comment tout cela fonctionne aujourd'hui.  Nous abordons les différents types d'actifs dans lesquels il est possible d'investir et explorons d'où proviennent les rendements.  Vous apprendrez des concepts d'investissement tels que le risque, la diversification, la valeur temps de l'argent, la valeur actuelle, le rendement à l'échéance et les courbes de rendement, pour n'en citer que quelques-uns.
Vous découvrirez les principaux acteurs du marché, tels que les teneurs de marché et les banques centrales.  Vous apprendrez toutes les bases du trading et aurez l'occasion de passer différents types d'ordres sur notre simulateur de trading.  Nous abordons également la question de la fraude tout au long du cours.<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Enfin, nous vous aidons à déterminer si vous êtes plutôt fait pour investir seul ou si vous préférez travailler avec un conseiller.
Comme toutes nos formations, Foundation inclut les dernières réflexions en matière d'investissement. Même si vous êtes un investisseur expérimenté, nous vous garantissons que vous apprendrez quelque chose de nouveau.`
            },
            iconUrl: "/assets/foundations2-300x200.png",
            
            cdnPrice: "$149.95",
            cdnDiscPrice: "$99.95",
            signupCode: 'found',
            note: `Note: this course is included for free with the purchase of any other course.`,
            langs: ['eng']
          },
          
      
          { 
            name: this.$t("Portfolio Management"), 
            shortDescription: {
              en: `Managing your portfolio to meet your goals takes knowledge, planning and execution, but it doesn't have to take a lot of time and effort.  Learn how to effectively manage your portfolio in this hands-on practical course.`, 
              fr: "La gestion de votre portefeuille pour atteindre vos objectifs nécessite des connaissances, une planification et une exécution rigoureuses, mais cela ne doit pas nécessairement demander beaucoup de temps et d'efforts.  Apprenez à gérer efficacement votre portefeuille dans ce cours pratique."
            },
            description: {
              en:`Building a goal achieving portfolio is not something that happens by accident or by making a few lucky stock picks.  Achieving your goals, whether it's retirement, buying a house, or investing for your children's education takes planning and execution.<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;In this course, you learn how to quantify your goals, develop a plan for achieving them, monitor your progress and course correct when necessary.  You'll learn how to transition your portfolio from the accumulation phase of the portfolio, to the harvest phase.
This course goes deeper into some subjects discussed in the Foundation course including compound growth, risk and return, diversification, and investment goals.  New material includes portfolio rebalancing and tilting, fees and taxes, and investment accounts.<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Included in the course are powerful tools like Portfolio Planner, Goal Mapping, Inflation Adjusted Target Date Goals, Adjusting Retirement Portfolio for Tax, a Diversification Matrix and an Allocation Matrix. <br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; What's extra special about this course is that you get to use these tools as you build your own portfolio using our trading simulator, research tools, and portfolio module.
Note: in this course, you use ETFs to build the portfolio, however, the same principles apply no matter what it holds.`,
              fr: `Construire un portefeuille qui vous permettra d'atteindre vos objectifs n'est pas le fruit du hasard ou de quelques choix judicieux.  Que vous souhaitiez prendre votre retraite, acheter une maison ou investir dans les études de vos enfants, vous devez planifier et agir pour atteindre vos objectifs.
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dans ce cours, vous apprendrez à quantifier vos objectifs, à élaborer un plan pour les atteindre, à suivre vos progrès et à corriger le tir si nécessaire.  Vous apprendrez comment faire passer votre portefeuille de la phase d'accumulation à la phase de récolte.
Ce cours approfondit certains sujets abordés dans le cours « Fondamentaux », notamment la croissance composée, le risque et le rendement, la diversification et les objectifs d'investissement.  Les nouveaux thèmes abordés comprennent le rééquilibrage et l'orientation du portefeuille, les frais et les taxes, ainsi que les comptes d'investissement. <br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Le cours comprend des outils puissants tels que le planificateur de portefeuille, la cartographie des objectifs, les objectifs à date cible ajustés en fonction de l'inflation, l'ajustement du portefeuille de retraite en fonction de la fiscalité, une matrice de diversification et une matrice d'allocation. <br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ce qui rend ce cours vraiment unique, c'est que vous pouvez utiliser ces outils pour créer votre propre portefeuille à l'aide de notre simulateur de trading, de nos outils de recherche et de notre module de portefeuille.
Remarque : dans ce cours, vous utilisez des ETF pour créer votre portefeuille, mais les mêmes principes s'appliquent quel que soit son contenu.`
            },
            iconUrl: "/assets/port-management-300x200.png",
            
            cdnPrice: "$149.95",
            cdnDiscPrice: "$99.95",
            signupCode: 'build',
            langs: ['eng']
          },
           { 
            name: this.$t("Stock Picking"), 
            shortDescription: {
              en: "There is a vast array of stock picking techniques but the best ones play to your strengths.  Learn which techniques work for you and build them into your own methodology for selecting companies.", 
              fr: "Il existe une multitude de techniques de sélection d'actions, mais les meilleures sont celles qui tirent parti de vos points forts.  Découvrez les techniques qui vous conviennent et intégrez-les à votre propre méthodologie de sélection des entreprises."
            },
            description: {
              en:`While stock picking isn’t a necessary skill for investing, after all, you can build a portfolio of ETFs, it is one of the most satisfying.  There’s nothing quite like seeing the fruits of your research bloom into a market beating gem.
In this course, you’ll learn multiple methods to used to select stocks including fundamental analysis, technical analysis, quantitative and opportunistic strategies.  The idea is to discover what you are good at, and then to develop your own system.    Using INVRS's data and tools, you can do exactly that.  As a bonus, Jennifer, the company's CEO shares her personal system and how she developed it.`,
              fr: `Bien que la sélection de titres ne soit pas une compétence indispensable pour investir, puisque vous pouvez constituer un portefeuille d'ETF, elle est l'une des plus gratifiantes.  Il n'y a rien de plus satisfaisant que de voir les fruits de vos recherches se transformer en une perle rare qui surpasse le marché.
Dans ce cours, vous apprendrez plusieurs méthodes de sélection des actions, notamment l'analyse fondamentale, l'analyse technique, les stratégies quantitatives et opportunistes.  L'idée est de découvrir ce que vous savez faire et de développer ensuite votre propre système.  Grâce aux données et aux outils d'INVRS, vous pouvez y parvenir.  En bonus, Jennifer, la PDG de l'entreprise, vous fait part de son système personnel et de la manière dont elle l'a développé.`
            },
            iconUrl: "/assets/stock-picking-300x200.png",
           
            cdnPrice: "$149.95",
            cdnDiscPrice: "$99.95",
            signupCode: 'pick',
            langs: ['eng']
          },
           { 
            name: this.$t("Bond Strategies"), 
            shortDescription: {
              en: "Some people perceive bonds as boring.  They see instruments without a lot of upside whose main benefit is they diversify stock holdings, but there's a lot more to them.", 
              fr: "Certaines personnes considèrent les obligations comme ennuyeuses.  Elles les voient comme des instruments sans grand potentiel de hausse, dont le principal avantage est de diversifier les portefeuilles d'actions, mais elles ont bien plus à offrir."
            },
            description: {
              en: `In this course, you'll learn about the basics of bonds and their place in a diversified, strong-returning portfolio.  We also cover the bond market, the roll of bonds in economics, how to build a portfolio and finally we get into more advanced bond strategies including carry trades, junk bonds, ladders, and barbells. `,
              fr: `Dans ce cours, vous apprendrez les bases des obligations et leur place dans un portefeuille diversifié et à rendement élevé.  Nous aborderons également le marché obligataire, le rôle des obligations dans l'économie, la manière de constituer un portefeuille et, enfin, nous nous intéresserons à des stratégies obligataires plus avancées, notamment les opérations de portage, les obligations à haut rendement, les stratégies en échelle et les stratégies en haltères.`
            },
            iconUrl: "/assets/bonds-300x200.png",
           
            cdnPrice: "$149.95",
            cdnDiscPrice: "$99.95",
            signupCode: 'bonds',
            langs: ['eng']
          },
          { 
            name: this.$t("Understanding Options"), 
            shortDescription: {
              en: "Obtain an in depth understanding of options: how they work, risks and pitfalls, strategies.", 
              fr: "Acquérez une compréhension approfondie des options : leur fonctionnement, leurs risques et leurs pièges, les stratégies à adopter."
            },
            description: {
              en: `<p class="value-description">
                              Options trading can be profitable, but only if you truly understand how options work, what the risks are and the strategies used to mitigate those risks.   
                              Without a firm grasp of these concepts, trading options can quickly lose you a lot of money.
                              This course was written by a CFA and is designed to give you a thorough hands on education about options and option trading strategies.
                  
                          </p>
                          <div class="course-outline">
                            <p class="value-description">Here's brief outline of what's covered in the course:</p>
                          <p class="value-description">
                              <ul class="course-outline-list value-description" style="padding-inline-start: revert;">
                                <li>Module 1: What options are, how they work, basic terminology, Profit Profiles.</li>
                                <li>Module 2: Intrinsic and Extrinsic Value, Time Decay, Volatility, Greeks.</li>
                                <li>Module 3: Beginner Strategies, Individual Trades, Spreads, Collars, Straddles, Strangles.</li>
                                <li>Module 4: Intermediate/Advanced Strategies, Iron Condor, Iron Butterfly, Calendar Spreads, Diagonal Spreads, Ratio Spreads, Rolling Options.</li>
                                <li>Module 5: Choosing Strategies that are right for you.</li>
                                
                              </ul>

                          </p>
                          </div>
                          <div>
                           <p class="value-description">
                            <br>
                            With access to our Options tools you can practice options trading in a <b>risk-free</b> environment.
                            </p>

                          </div>`,
              fr: `Acquérez une compréhension approfondie des options : leur fonctionnement, leurs risques et leurs pièges, les stratégies. Entraînez-vous à investir dans des options dans un environnement sans risque.`
            },
            iconUrl: "/assets/options-300x175.png",
            cdnPrice: "$149.95",
            cdnDiscPrice: "$99.95",
            signupCode: 'options',
            langs: ['eng'],
            video: 'https://docs.invrs.com/public/UnderstandingOption-Overview-comp.mp4',
            poster: 'https://docs.invrs.com/public/optionsOverviewThumb.png'
           
            
            
          },
           { 
            name: this.$t("Market Expectations"), 
            shortDescription: {
              en: "Coming Soon: Learn the art and science of forming market expectations in this powerful course.", 
              fr: "À venir : Apprenez l'art et la science de la formation des attentes du marché dans ce cours très complet."
            },
            description: {
              en: `Coming Soon: Moving into markets, asset classes, and sectors before they become hot and out before they cool is a skill that will make a profound impact on your portfolio. Learn the art and science of forming market expectations in this powerful course.`,
              fr: `À venir : Entrer sur les marchés, dans les classes d'actifs et les secteurs avant qu'ils ne deviennent populaires et en sortir avant qu'ils ne perdent de leur attrait est une compétence qui aura un impact considérable sur votre portefeuille. Apprenez l'art et la science de la formation des anticipations du marché dans ce cours très complet.`
            },
            iconUrl: "/assets/expect-300x200.png",
            langs: ['eng']
           
            
            
          },
        ],

        litCourses: [
           { 
            name: this.$t("Financial Literacy for Everyone"), 
            shortDescription: {
              en: "This comprehensive course is designed to equip learners with essential financial knowledge and skills that are crucial for managing money effectively.",
              fr: "Ce cours complet est conçu pour doter les apprenants des connaissances et compétences financières essentielles à une gestion efficace de leur argent."
            }, 
            description: {
              en: `This comprehensive course is designed to equip learners with essential financial knowledge and skills that are crucial for managing money effectively and making informed financial decisions. Through engaging lessons, real-life examples, and practical activities, students will learn to navigate the financial world with confidence and build a strong foundation for their financial future.`,
              fr: `Ce cours complet est conçu pour doter les apprenants des connaissances et compétences financières essentielles à une gestion efficace de leur argent et à la prise de décisions financières éclairées. Grâce à des leçons captivantes, des exemples concrets et des activités pratiques, les étudiants apprendront à naviguer dans le monde financier en toute confiance et à bâtir des bases solides pour leur avenir financier.`
            }, 
            iconUrl: "/assets/fin-lit-300x200.png",
          
            cdnPrice: "$149.95",
            cdnDiscPrice: "$99.95",
            signupCode: 'lit',
            langs: ['eng', 'fr']
          },
          { 
            name: this.$t("Mastering Debt"), 
            shortDescription: {
              en: 'Knowledge, strategies, and practical tools to understand, manage, and eliminate debt.', 
              fr: "Connaissances, stratégies et outils pratiques pour comprendre, gérer et éliminer l'endettement."
            },
            description: {
              en: `This course aims to empower learners with the knowledge, strategies, and practical tools to understand, manage, and eliminate debt. Learners will explore the nature of debt, differentiate between good and bad debt, and discover how to break free from the debt cycle. By the end of the course, participants will develop a clear, personalized debt-repayment plan and learn how to build sustainable financial habits.`, 
              fr: `Ce cours vise à donner aux apprenants les connaissances, les stratégies et les outils pratiques nécessaires pour comprendre, gérer et éliminer leurs dettes. Les apprenants exploreront la nature de la dette, apprendront à distinguer les bonnes et les mauvaises dettes et découvriront comment sortir du cycle de l'endettement. À la fin du cours, les participants auront élaboré un plan de remboursement clair et personnalisé et auront appris à adopter des habitudes financières durables.`
            },
            iconUrl: "/assets/debt-300x200.png",
          
            cdnPrice: "$149.95",
            cdnDiscPrice: "$99.95",
            signupCode: 'debt',
            langs: ['eng']
          },
        ]
        ,

        customCourses: [
          { 
            name: this.$t("Introduction to Financial Careers"), 
            shortDescription: {
              en:"This comprehensive course is designed to provide learners with a thorough understanding of various careers within the financial industry.", 
              fr: "Ce cours complet est conçu pour permettre aux apprenants d'acquérir une compréhension approfondie des différentes carrières dans le secteur financier."
            },
            description: {
              en: `This comprehensive course is designed to provide learners with a thorough understanding of various careers within the financial industry. Through detailed lessons, real-world insights, and practical knowledge, students will explore roles in banking, financial planning, corporate finance, and more, equipping them with the tools and information needed to pursue a successful career in finance.`,
              fr: `Ce cours complet est conçu pour fournir aux apprenants une compréhension approfondie des différentes carrières dans le secteur financier. Grâce à des leçons détaillées, des aperçus concrets et des connaissances pratiques, les étudiants exploreront les rôles dans le domaine bancaire, la planification financière, la finance d'entreprise et bien plus encore, ce qui leur permettra d'acquérir les outils et les informations nécessaires pour mener une carrière réussie dans la finance.`
            },
            iconUrl: "/assets/career-300x200.png",
            
            cdnPrice: "$149.95",
            cdnDiscPrice: "$99.95",
            signupCode: 'career',
            langs: ['eng']
          },
          { 
            name: this.$t("Recruitment Prep"), 
            shortDescription: {
              en:"The competition for internships at top investment firms is fierce. Give yourself an edge with Recruitment Prep.", 
              fr:"La concurrence pour décrocher un stage dans les meilleures sociétés d'investissement est rude. Donnez-vous un avantage avec Préparation au recrutement."
            },

            description: {
              en: `The competition for internships at top investment firms is fierce. Give yourself an edge with Recruitment Prep, the course to train finance students in landing their dream internship.`,
              fr: `La concurrence pour décrocher un stage dans les meilleures sociétés d'investissement est rude. Donnez-vous un avantage avec Préparation au recrutement, la formation qui aide les étudiants en finance à décrocher le stage de leurs rêves.`
            },
            iconUrl: "/assets/recruit-300x200.png",
           
            cdnPrice: "$149.95",
            cdnDiscPrice: "$99.95",
            signupCode: 'prep',
            langs: ['eng']

          },
           { 
            name: this.$t("Game Plan: Financial Literacy for Elite Athletes"), 
            shortDescription: {
              en:"This course equips CHL and NHL players with essential financial literacy skills to navigate sudden wealth.", 
              fr: "Ce cours permet aux joueurs de la LCH et de la LNH d'acquérir les compétences financières essentielles pour gérer une richesse soudaine."
            },
            description: {
              en: `This course equips CHL and NHL players with essential financial literacy skills to navigate sudden wealth. Covering topics like contract breakdowns, agent fees, and investment strategies, it emphasizes the importance of budgeting, long-term planning, and the value of higher education. Players will learn to establish a division of duties among financial advisors to protect their interests and adapt their mindset from immediate gratification to sustainable wealth growth. This practical guide aims to empower athletes to make informed financial decisions that ensure lasting financial success both on and off the ice.`,
              fr: `Ce cours permet aux joueurs de la LCH et de la LNH d'acquérir les compétences financières essentielles pour gérer une richesse soudaine. Abordant des sujets tels que la rupture de contrat, les honoraires des agents et les stratégies d'investissement, il met l'accent sur l'importance de la budgétisation, de la planification à long terme et de la valeur des études supérieures. Les joueurs apprendront à répartir les tâches entre leurs conseillers financiers afin de protéger leurs intérêts et à adopter un état d'esprit axé sur la croissance durable de leur patrimoine plutôt que sur la gratification immédiate. Ce guide pratique vise à donner aux athlètes les moyens de prendre des décisions financières éclairées qui leur assureront une réussite financière durable, tant sur la glace qu'en dehors.`
            },
            iconUrl: "/assets/game-300x200.png",
            
            cdnPrice: "$149.95",
            cdnDiscPrice: "$99.95",
            signupCode: 'game',
            langs: ['eng']
          },
           { 
            name: this.$t("Your Customized Course"), 
            shortDescription: {
              en:"If you are a charity, sports organization, school, or corporation we're your one-stop resource for customizable and compelling financial education.", 
              fr: "Si vous êtes une organisation caritative, une association sportive, une école ou une entreprise, nous sommes votre ressource unique pour une éducation financière personnalisable et convaincante."
            },
            description: {
              en: `If you are a charity, sports organization, school, or corporation we're your one-stop resource for customizable and compelling financial education.  Designed and delivered to meet the specific needs of your members and their financial health.`,
              fr: `Si vous êtes une organisation caritative, une association sportive, une école ou une entreprise, nous sommes votre ressource unique pour une formation financière personnalisable et convaincante.  Conçue et dispensée pour répondre aux besoins spécifiques de vos membres et à leur santé financière.`
            },
            iconUrl: "/assets/custom-300x200.png",
            langs: ['eng']
            
          },
        ],
       

        
      };
    },
    mounted() {
     console.log("current locale "+ i18nService.currentLocale)
    },
    methods: {

      isQTradeOn() {
        return QTRADE_REF_ON;
      },

      openCourseInfo(course) {
        this.$refs.courseInfoModal.open(course);
      },

      revealFounders() {
        //this.ceoFounder.classList.remove("hidden-founder");
        this.ctoFounder.classList.remove("hidden-founder");
      },
      revealHero() {
        this.revealFounders();
      },
      goToSignup(courseCode) {
        //evt.preventDefault();
        if( courseCode ){
          window.location.href = SIGNUP_URL+"?courseCode="+courseCode;
        }
        else {
          window.location.href = SIGNUP_URL
        }

        
      },
      getShortDesc(course){
        return course.shortDescription[i18nService.currentLocale];
      }
    },
  };
  </script>
  
  <style scoped>

    .course-line{
      
    }

    .course-div{
      /*min-width:20rem;*/
    }
    ::v-deep(.emph){
      text-decoration: underline;
    }
    ::v-deep(.p-card .p-card-title){
      font-size: 2rem;
    }

    ::v-deep(.p-card-content){
      font-size: 2rem;
    }

    .course-info{
      display:flex;
      flex-direction:column;
      height:100%;
      min-height:100%;
      padding:5px;
    }
    .course-desc-cont{
      flex-grow: 1;
    }
    .course-box{
      display:flex;
      height:100%;
      cursor: pointer;
      flex-direction:row;
    }

    .course-img {
      max-width: 25rem;
      max-height: 25rem;
      margin-top: 1rem;
    }
    .course-price-label{
      font-size: 1.8rem;
      margin-right:auto;
    }

    .course-price{
      font-size: 1.8rem;
      margin-left:auto;
    }
    .course-pricing{
      display:flex;
      flex-direction: column;
      
      margin-left: 1rem;
      align-items: end;
    }
    .course-pricing-cont{
      display:flex;
      flex-direction: row;
      
      
      align-items: end;
      width: 100%;
    }

    .pricing-header{
      background-color:#ffffff;
      display:flex;
      flex-direction: column;
      margin-top:1rem;
      /*max-width: 30rem;*/
      align-items: baseline;
      align-self: flex-start;
      /*width: 100%;*/
    }

  .more-info{
    cursor:pointer;
    color:#33cc99;
    font-size: 1.2rem;
  }

  a.cta{
    padding: .8rem 1.3rem;
    align-self: center;
    margin-left:auto;
    font-size: 1.5rem;
    margin-top: 1rem;
  }

    .custom-text {
      padding-bottom:5rem;
    }
    .custom-section{
      align-items: center;
    }
    .custom-course-img{
      max-width:45rem;
    }
    .value-description{
      margin-bottom: 0;
    }

    .value-description {
    font-size: 1.5rem;
    line-height: 2.6rem;
  }

    .heading-course-cat {
      font-size: 3.2rem;
      color: #333;
      margin-bottom: 2.8rem;
      line-height: 1.1;
    }

   .courses-header{
      flex-direction: column;
   }

  .grid--2-cols {
      grid-template-columns: repeat(2, 1fr);
  }

  .key-points{
    margin-top:2rem;
  }

  .section-hero {
    position: relative;
    padding: 12.8rem 0 9.6rem 0;
    
  }
  
  .hero-content {
    max-width: 130rem;
    margin: 0 auto;
    padding: 0 3.6rem;
  }

  .heading-primary {
    margin-bottom: 3.8rem;
  }

  .hidden-founder {
    opacity: 0;
  }
  .hidden-content {
    transform: translateX(-9.6rem);
    opacity: 0;
  }
  .hidden-founder.ceo-founder {
    transform: translateX(-9.6rem);
  }

  .main-section {
    display: flex;
    align-items: flex-start;
    margin-bottom: 5rem;
    transition: all 0.6s ease-in;
    padding-left: 11rem;
  }

  .hero-founder {
    display: flex;
    align-items: center;
    margin-bottom: 3rem;
    margin-top: 3rem;
    transition: all 0.6s ease-in;
  }
  .hero-founder:last-of-type() {
    margin-bottom: 0;
  }

  .founder-heading {
    color: #32364e;
    font-size: 2.5rem;
  }

  .founder-avatar {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .founder-avatar .p-avatar {
    width: 18rem;
    height: 18rem;
    border: 3px solid #32364e;
  }

  .main-side {
    padding: 2rem;
    
    line-height: 1.6;
    
    max-width: 100rem;
    font-size:6rem;
    margin-left:3rem;
   
  }

  .section-header {
    text-align: center;
  }

  .founder-description {
    padding: 2rem;
    border-radius: 25px;
    line-height: 1.6;
    color: #333;
    max-width: 100rem;
    background: #fff;
    box-shadow: 0 0 2.4rem hsl(231deg 22% 25% / 20%);
  }

  .ceo-founder .founder-avatar {
    /*margin-right: 6rem;*/
  }
  
  .hidden-founder.cto-founder {
    transform: translateX(9.6rem);
  }

  .cto-founder {
    flex-direction: row-reverse;
  }
  
  .cto-founder .founder-avatar {
    margin-left: 6rem;
  }

   .heading-primary {
      font-size: 4rem;
      text-align: center;
    }

  .heading-secondary {
    font-size: 2rem;
    margin-bottom: 1rem;
  }

  .signup-free{
   
    margin-bottom: 1rem;
  }

button {
  font-family: inherit;
  cursor: pointer;
  font-weight: 500;
  color: #fff;
  transition: all 0.2s;
  padding: 10px 20px;
  border-radius: 0.8rem;
  background-image: linear-gradient(
    to right,
    rgb(105, 59, 245, 1),
    rgb(105, 59, 245, 0.85),
    rgb(105, 59, 245, 0.7)
  );
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  font-size: 2rem;
  max-width: fit-content;
}

button:hover {
  box-shadow: 0 0.4rem 3.2rem rgb(105, 59, 245, 0.6);
  transform: scale(1.05);
}

button > svg {
  width: 3.6rem;
  margin-left: 1rem;
  transition: transform 0.3s ease-in-out;
  font-weight: 700;
}

button:hover svg {
  transform: translateX(5px);
}

button:active {
  transform: scale(0.95);
}



  /* **************************** */
  /* BELOW 1360px (Small desktop/laptop) */
  /* **************************** */
  @media (max-width: 85em) {
    .hero-content {
        max-width: 150rem;
    }
  
    .heading-primary {
      font-size: 4rem;
    }

    .founder-description {
        max-width: 75rem;
    }

    .main-side {
      max-width: 75rem;
    }
  }
  
  /* **************************** */
  /* BELOW 976px (landscape tablets) */
  /* **************************** */
  @media (max-width: 61em) {
    .hero-content {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .hero-founder {
        flex-direction: column;
        justify-content: center;
    }

    .founder-avatar {
        margin: 0 6rem 0;
    }

    .founder-description,
    .cto-founder .founder-description  {
        text-align: center;
        max-width: 90rem;
    }

    .main-side {
      text-align: center;
      max-width: 50rem;
      align-items: center;
      justify-content: center;
      display:flex;
      flex-direction: column;

    }
    .grid--2-cols {
         grid-template-columns: 1fr;
    }

    .custom-text {
      padding-bottom:0;
    }

    .custom-course-img{
      max-width:35rem;
    }
           
    .heading-primary {
      font-size: 3.6rem;
    }

    .heading-secondary {
      margin-bottom: 1rem;
    }
    /*
    .heading-course-cat {
      margin-bottom: 2.8rem;
    }*/

    .container{
      max-width: 100%;
      padding: 0;
    }

    .main-section{
      padding-left: 0;
    }
  }
  
  /* **************************** */
  /* BELOW 800px (tablet) */
  /* **************************** */
  @media (max-width: 50em) {
  }
  
  /* **************************** */
  /* BELOW 592px (mobile) */
  /* **************************** */
  @media (max-width: 37em) {
    .course-desc-cont{
      flex-grow: 0;
    }
    .course-box{
      flex-direction:column;
    }
    .heading-primary {
      font-size: 3rem;
    }

    .founder-heading {
        font-size: 2rem;
    }

    .founder-avatar .p-avatar {
        width: 15rem;
        height: 15rem;
    }

    .founder-description {
        padding: 1.2rem;
        font-size: 1.8rem;
        border-radius: 10px;
    }

    .main-side {
      font-size: 3rem;
      margin-left: 0;
    }
  }
  
  /* **************************** */
  /* BELOW 496px (mobile) */
  /* **************************** */
  @media (max-width: 31em) {
    .heading-primary {
      font-size: 2.4rem;
    }

    .heading-secondary {
      margin-bottom: 1rem;
    }

     button {
      padding: 8px 16px;
    }
  }

  /*** Grid */

  ::v-deep(.grid) {
    display: flex !important;
    flex-wrap: wrap;
    margin-left: -.5rem;
    margin-right: -.5rem;
    margin-top: -.5rem;
    column-gap: unset;
    row-gap: 4rem;
}

::v-deep(.grid>.col,.grid>[class*=col]) {
    box-sizing: border-box
}

::v-deep(.grid-nogutter) {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0
}

::v-deep(.grid-nogutter>.col,.grid-nogutter>[class*=col-]) {
    padding: 0
}

::v-deep(.p2){
  padding: .5rem !important;
}

::v-deep(.col) {
    flex-basis: 0;
    flex-grow: 1;
    padding: .5rem
}

::v-deep(.col-1,.col-fixed) {
    flex: 0 0 auto;
    padding: .5rem
}

::v-deep(.col-1) {
    width: 8.3333%
}

::v-deep(.col-2) {
    width: 16.6667%
}

::v-deep(.col-2,.col-3) {
    flex: 0 0 auto;
    padding: .5rem
}

::v-deep(.col-3) {
    width: 25%
}

::v-deep(.col-4) {
    width: 33.3333%
}

.col-4,.col-5 {
    flex: 0 0 auto;
    padding: .5rem
}

.col-5 {
    width: 41.6667%
}

.col-6 {
    width: 50%
}

.col-6,.col-7 {
    flex: 0 0 auto;
    padding: .5rem
}

.col-7 {
    width: 58.3333%
}

.col-8 {
    width: 66.6667%
}

.col-8,.col-9 {
    flex: 0 0 auto;
    padding: .5rem
}

.col-9 {
    width: 75%
}

.col-10 {
    width: 83.3333%
}

.col-10,.col-11 {
    flex: 0 0 auto;
    padding: .5rem
}

.col-11 {
    width: 91.6667%
}

::v-deep(.col-12) {
    flex: 0 0 auto;
    padding: .5rem;
    width: 100%
}

@media screen and (min-width: 576px) {
    .sm\:col {
        flex-basis:0;
        flex-grow: 1;
        padding: .5rem
    }

    .sm\:col-1,.sm\:col-fixed {
        flex: 0 0 auto;
        padding: .5rem
    }

    .sm\:col-1 {
        width: 8.3333%
    }

    .sm\:col-2 {
        width: 16.6667%
    }

    .sm\:col-2,.sm\:col-3 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .sm\:col-3 {
        width: 25%
    }

    .sm\:col-4 {
        width: 33.3333%
    }

    .sm\:col-4,.sm\:col-5 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .sm\:col-5 {
        width: 41.6667%
    }

    ::v-deep(.sm\:col-6) {
        width: 50%
    }

    ::v-deep(.sm\:col-6,.sm\:col-7) {
        flex: 0 0 auto;
        padding: .5rem
    }

    .sm\:col-7 {
        width: 58.3333%
    }

    .sm\:col-8 {
        width: 66.6667%
    }

    .sm\:col-8,.sm\:col-9 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .sm\:col-9 {
        width: 75%
    }

    .sm\:col-10 {
        width: 83.3333%
    }

    .sm\:col-10,.sm\:col-11 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .sm\:col-11 {
        width: 91.6667%
    }

    .sm\:col-12 {
        flex: 0 0 auto;
        padding: .5rem;
        width: 100%
    }
}

@media screen and (min-width: 768px) {
    .md\:col {
        flex-basis:0;
        flex-grow: 1;
        padding: .5rem
    }

    .md\:col-1,.md\:col-fixed {
        flex: 0 0 auto;
        padding: .5rem
    }

    .md\:col-1 {
        width: 8.3333%
    }

    .md\:col-2 {
        width: 16.6667%
    }

    .md\:col-2,.md\:col-3 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .md\:col-3 {
        width: 25%
    }

    ::v-deep(.md\:col-4) {
        width: 33.3333%
    }

    ::v-deep(.md\:col-4,.md\:col-5 ){
        flex: 0 0 auto;
        padding: .5rem
    }

    .md\:col-5 {
        width: 41.6667%
    }

    .md\:col-6 {
        width: 50%
    }

    .md\:col-6,.md\:col-7 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .md\:col-7 {
        width: 58.3333%
    }

    .md\:col-8 {
        width: 66.6667%
    }

    .md\:col-8,.md\:col-9 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .md\:col-9 {
        width: 75%
    }

    .md\:col-10 {
        width: 83.3333%
    }

    .md\:col-10,.md\:col-11 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .md\:col-11 {
        width: 91.6667%
    }

    .md\:col-12 {
        flex: 0 0 auto;
        padding: .5rem;
        width: 100%
    }
}

@media screen and (min-width: 992px) {
    .lg\:col {
        flex-basis:0;
        flex-grow: 1;
        padding: .5rem
    }

    .lg\:col-1,.lg\:col-fixed {
        flex: 0 0 auto;
        padding: .5rem
    }

    .lg\:col-1 {
        width: 8.3333%
    }

    .lg\:col-2 {
        width: 16.6667%
    }

    .lg\:col-2,.lg\:col-3 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .lg\:col-3 {
        width: 25%
    }

    .lg\:col-4 {
        width: 33.3333%
    }

    .lg\:col-4,.lg\:col-5 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .lg\:col-5 {
        width: 41.6667%
    }

    .lg\:col-6 {
        width: 50%
    }

    .lg\:col-6,.lg\:col-7 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .lg\:col-7 {
        width: 58.3333%
    }

    .lg\:col-8 {
        width: 66.6667%
    }

    .lg\:col-8,.lg\:col-9 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .lg\:col-9 {
        width: 75%
    }

    .lg\:col-10 {
        width: 83.3333%
    }

    .lg\:col-10,.lg\:col-11 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .lg\:col-11 {
        width: 91.6667%
    }

    .lg\:col-12 {
        flex: 0 0 auto;
        padding: .5rem;
        width: 100%
    }
}

@media screen and (min-width: 1200px) {
    ::v-deep(.xl\:col) {
        flex-basis:0;
        flex-grow: 1;
        padding: .5rem
    }

    .xl\:col-1,.xl\:col-fixed {
        flex: 0 0 auto;
        padding: .5rem
    }

    .xl\:col-1 {
        width: 8.3333%
    }

    .xl\:col-2 {
        width: 16.6667%
    }

    .xl\:col-2,.xl\:col-3 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .xl\:col-3 {
        width: 25%
    }

    .xl\:col-4 {
        width: 33.3333%
    }

    .xl\:col-4,.xl\:col-5 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .xl\:col-5 {
        width: 41.6667%
    }

    .xl\:col-6 {
        width: 50%
    }

    .xl\:col-6,.xl\:col-7 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .xl\:col-7 {
        width: 58.3333%
    }

    .xl\:col-8 {
        width: 66.6667%
    }

    .xl\:col-8,.xl\:col-9 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .xl\:col-9 {
        width: 75%
    }

    .xl\:col-10 {
        width: 83.3333%
    }

    .xl\:col-10,.xl\:col-11 {
        flex: 0 0 auto;
        padding: .5rem
    }

    .xl\:col-11 {
        width: 91.6667%
    }

    .xl\:col-12 {
        flex: 0 0 auto;
        padding: .5rem;
        width: 100%
    }
}

.col-offset-0 {
    margin-left: 0!important
}

.col-offset-1 {
    margin-left: 8.3333%!important
}

.col-offset-2 {
    margin-left: 16.6667%!important
}

.col-offset-3 {
    margin-left: 25%!important
}

.col-offset-4 {
    margin-left: 33.3333%!important
}

.col-offset-5 {
    margin-left: 41.6667%!important
}

.col-offset-6 {
    margin-left: 50%!important
}

.col-offset-7 {
    margin-left: 58.3333%!important
}

.col-offset-8 {
    margin-left: 66.6667%!important
}

.col-offset-9 {
    margin-left: 75%!important
}

.col-offset-10 {
    margin-left: 83.3333%!important
}

.col-offset-11 {
    margin-left: 91.6667%!important
}

.col-offset-12 {
    margin-left: 100%!important
}

@media screen and (min-width: 576px) {
    .sm\:col-offset-0 {
        margin-left:0!important
    }

    .sm\:col-offset-1 {
        margin-left: 8.3333%!important
    }

    .sm\:col-offset-2 {
        margin-left: 16.6667%!important
    }

    .sm\:col-offset-3 {
        margin-left: 25%!important
    }

    .sm\:col-offset-4 {
        margin-left: 33.3333%!important
    }

    .sm\:col-offset-5 {
        margin-left: 41.6667%!important
    }

    .sm\:col-offset-6 {
        margin-left: 50%!important
    }

    .sm\:col-offset-7 {
        margin-left: 58.3333%!important
    }

    .sm\:col-offset-8 {
        margin-left: 66.6667%!important
    }

    .sm\:col-offset-9 {
        margin-left: 75%!important
    }

    .sm\:col-offset-10 {
        margin-left: 83.3333%!important
    }

    .sm\:col-offset-11 {
        margin-left: 91.6667%!important
    }

    .sm\:col-offset-12 {
        margin-left: 100%!important
    }
}

@media screen and (min-width: 768px) {
    .md\:col-offset-0 {
        margin-left:0!important
    }

    .md\:col-offset-1 {
        margin-left: 8.3333%!important
    }

    .md\:col-offset-2 {
        margin-left: 16.6667%!important
    }

    .md\:col-offset-3 {
        margin-left: 25%!important
    }

    .md\:col-offset-4 {
        margin-left: 33.3333%!important
    }

    .md\:col-offset-5 {
        margin-left: 41.6667%!important
    }

    .md\:col-offset-6 {
        margin-left: 50%!important
    }

    .md\:col-offset-7 {
        margin-left: 58.3333%!important
    }

    .md\:col-offset-8 {
        margin-left: 66.6667%!important
    }

    .md\:col-offset-9 {
        margin-left: 75%!important
    }

    .md\:col-offset-10 {
        margin-left: 83.3333%!important
    }

    .md\:col-offset-11 {
        margin-left: 91.6667%!important
    }

    .md\:col-offset-12 {
        margin-left: 100%!important
    }
}

@media screen and (min-width: 992px) {
    .lg\:col-offset-0 {
        margin-left:0!important
    }

    .lg\:col-offset-1 {
        margin-left: 8.3333%!important
    }

    .lg\:col-offset-2 {
        margin-left: 16.6667%!important
    }

    .lg\:col-offset-3 {
        margin-left: 25%!important
    }

    .lg\:col-offset-4 {
        margin-left: 33.3333%!important
    }

    .lg\:col-offset-5 {
        margin-left: 41.6667%!important
    }

    .lg\:col-offset-6 {
        margin-left: 50%!important
    }

    .lg\:col-offset-7 {
        margin-left: 58.3333%!important
    }

    .lg\:col-offset-8 {
        margin-left: 66.6667%!important
    }

    .lg\:col-offset-9 {
        margin-left: 75%!important
    }

    .lg\:col-offset-10 {
        margin-left: 83.3333%!important
    }

    .lg\:col-offset-11 {
        margin-left: 91.6667%!important
    }

    .lg\:col-offset-12 {
        margin-left: 100%!important
    }
}

@media screen and (min-width: 1200px) {
    .xl\:col-offset-0 {
        margin-left:0!important
    }

    .xl\:col-offset-1 {
        margin-left: 8.3333%!important
    }

    .xl\:col-offset-2 {
        margin-left: 16.6667%!important
    }

    .xl\:col-offset-3 {
        margin-left: 25%!important
    }

    .xl\:col-offset-4 {
        margin-left: 33.3333%!important
    }

    .xl\:col-offset-5 {
        margin-left: 41.6667%!important
    }

    .xl\:col-offset-6 {
        margin-left: 50%!important
    }

    .xl\:col-offset-7 {
        margin-left: 58.3333%!important
    }

    .xl\:col-offset-8 {
        margin-left: 66.6667%!important
    }

    .xl\:col-offset-9 {
        margin-left: 75%!important
    }

    .xl\:col-offset-10 {
        margin-left: 83.3333%!important
    }

    .xl\:col-offset-11 {
        margin-left: 91.6667%!important
    }

    .xl\:col-offset-12 {
        margin-left: 100%!important
    }
}
.relative {
    position: relative !important;
}
.mx-auto {
    /*margin-left: auto !important; */
    /* margin-right: auto !important; */
}
  </style>
  